import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/Accordion';
export function FAQSection() {
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="max-w-3xl mx-auto" data-id="element-3">
          <div className="text-center mb-12" data-id="element-4">
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4 font-serif" data-id="element-5">
              Preguntas Frecuentes
            </h2>
          </div>

          <Accordion type="single" collapsible className="w-full" data-id="element-6">
            <AccordionItem value="item-1" data-id="element-7">
              <AccordionTrigger data-id="element-8">
                ¿Cuánto tiempo debo usarlo para ver resultados?
              </AccordionTrigger>
              <AccordionContent data-id="element-9">
                El alivio del dolor inflamatorio ("fuego") suele notarse desde
                las primeras noches de uso. La corrección mecánica visible
                depende del grado de desviación, pero nuestras clientas reportan
                cambios significativos a partir de los 30 días de uso constante
                nocturno.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-2" data-id="element-10">
              <AccordionTrigger data-id="element-11">¿Es incómodo para dormir?</AccordionTrigger>
              <AccordionContent data-id="element-12">
                El Kit Premium está diseñado específicamente para uso nocturno
                con materiales acolchados y transpirables. Puede sentir una leve
                presión las primeras noches (señal de que está trabajando), pero
                es totalmente ajustable para su comodidad.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-3" data-id="element-13">
              <AccordionTrigger data-id="element-14">
                ¿Sirve si ya tengo el juanete muy avanzado?
              </AccordionTrigger>
              <AccordionContent data-id="element-15">
                Sí. En casos avanzados, el objetivo principal es frenar el
                avance de la deformidad y eliminar el dolor para evitar la
                cirugía. El protocolo de desinflamación es efectivo
                independientemente del grado de desviación.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-4" data-id="element-16">
              <AccordionTrigger data-id="element-17">¿Cómo accedo al Ebook?</AccordionTrigger>
              <AccordionContent data-id="element-18">
                Inmediatamente después de tu compra, recibirás un correo
                electrónico con el acceso para descargar el Ebook "Protocolo
                Pies Sin Presión" y comenzar el tratamiento biológico mientras
                esperás el envío del kit físico.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-5" data-id="element-19">
              <AccordionTrigger data-id="element-20">¿Hacen envíos a todo el país?</AccordionTrigger>
              <AccordionContent data-id="element-21">
                Sí, realizamos envíos bonificados a toda la Argentina a través
                de correo privado con seguimiento online.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </section>;
}